import React, { useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet"; // Import Leaflet for custom marker icons
import "leaflet/dist/leaflet.css";

export default function Map({ address, setCoords, dragable,click }) {
  // const position = [address.lat, address.lng];
console.log(address,'address');

  // Create a custom marker icon if needed
  const icon = new L.Icon({
    iconUrl: "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png", // Default marker icon URL
    iconSize: [25, 41], // Size of the icon
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });
  const [position, setPosition] = useState([address.lat, address.lng]);

  const handleDragEnd = (event) => {
    const marker = event.target; // Get the marker that was dragged
    const newPosition = marker.getLatLng(); // Get the new coordinates

    // Update the marker position
    setPosition([newPosition.lat, newPosition.lng]);
    setCoords({ x: newPosition.lat, y: newPosition.lng });
    // Optionally, update the address dynamically here (via reverse geocoding)
  };

  const MapClickHandler = ({enableClick}) => {
    useMapEvents({
      click: (event) => {
        if (enableClick) {
        const { lat, lng } = event.latlng; // Get the clicked coordinates
        // Update marker position to the clicked point
        setPosition([lat, lng]);
        setCoords({ x: lat, y: lng });
      }
    }
    });
    return null;
  };

  return (
    <div>
      <MapContainer
        center={position}
        zoom={15}
        style={{ width: "100%", height: "400px" }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <MapClickHandler enableClick={click} />
        <Marker
          position={position}
          icon={icon}
          draggable={dragable} // Make the marker draggable
          eventHandlers={{
            dragend: handleDragEnd, // Attach the dragend event handler
          }}
        >
          <Popup>
            {address.address}, {address.city}, {address.state}, {address.zip}
          </Popup>
        </Marker>
      </MapContainer>
    </div>
  );
}
